module.exports = __webpack_public_path__ + "media/src/images/invoice-05-43913b48b6ad4a6af01ead82910b8b50.png";